// src/pages/meaning.js
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import './meaning.css';

const Meaning = () => {
  return (
    <div className="meaning-page-container app-content">
      <Navbar />

      <section className="meaning-card-container">
        <motion.div
          className="meaning-card"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <h2 className="meaning-title">What Does Sapiencia Mean?</h2>
          <div className="meaning-underline"></div>

          <p>
            Sapiencia comes from the Latin word <strong>sapientia</strong>, which means:
          </p>

          <ul className="meaning-list">
            <li>wisdom</li>
            <li>discernment</li>
            <li>deep knowledge or understanding</li>
            <li>the ability to apply intelligence wisely</li>
          </ul>

          <p>
            It is the same root found in words like <strong>sapient</strong> (wise or intelligent)
            and <strong>Homo sapiens</strong> (wise human).
          </p>

          <p>Sapiencia conveys the idea of:</p>

          <ul className="meaning-list">
            <li>intelligent insight</li>
            <li>applied wisdom</li>
            <li>knowledge turned into action</li>
            <li>thoughtful, informed decision-making</li>
          </ul>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default Meaning;
